import React, { useEffect, useState } from 'react'
import EscapeRoomOpen from './EscapeRoomOpen'
import { demoGameStatus, demoProfileInfo, demoSubjectAccessList, selectedSubjectDataValue } from './openGameUtil'

const DemoGameLoad = () => {
    const [isLoaded, setIsLoaded] = useState(false)

    const role = localStorage.getItem("role")

    useEffect(() => {
        setGameDataToLocalStorage()

        return () => {
            localStorage.clear()
        }
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (role) {
            setIsLoaded(true)
        }
        //eslint-disable-next-line
    }, [role])

    function setGameDataToLocalStorage() {

        // ✅ Store everything in localStorage
        localStorage.setItem("gamesStatus", JSON.stringify(demoGameStatus));
        localStorage.setItem("profileInfo", JSON.stringify(demoProfileInfo));
        localStorage.setItem("role", role);
        localStorage.setItem("selectedSubjectDataValue", JSON.stringify(selectedSubjectDataValue));
        localStorage.setItem("subjectAccessList", JSON.stringify(demoSubjectAccessList));
    }

    return (
        <>
            {isLoaded ? <EscapeRoomOpen /> : <></>}
        </>
    )
}

export default DemoGameLoad